import React from 'react'
import PostsStoriesTop from './PostsStoriesTop'
import ClientReview from '../clientReview/ClientReview'
import PostsStoriesBottom from './PostsStoriesBottom'

const ProfilePostsStories = () => {
  return (
    <div className='dashboard-content-box dashboard-posts-stories pt-0'>
       <div className='top-posts-stories-box'>
            <PostsStoriesTop />
        </div>
        <div className='client-reviews-sec'>
            <ClientReview />
        </div>
        <div className='posts-stories-bottom-follow-sec'>
            <PostsStoriesBottom />
        </div>
    </div>
  )
}

export default ProfilePostsStories
